import React from 'react';

import { SellingPoint } from '../../../components/custom';

interface Props {
  mainContent: React.ReactNode;
  sideContent: React.ReactNode;
  sampleTipType?: string;
}

const PageWithSideBar: React.FC<Props> = (props) => {
  const { mainContent, sideContent, sampleTipType } = props;

  return (
    <div className="flex flex-col lg:flex-row justify-between gap-3">
      <div className="flex flex-col gap-6 lg:w-[55%]">{mainContent}</div>

      <div className="border-r border-grey-200 border-solid" />

      <div className="flex flex-col gap-6 lg:w-[37%]">
        {!!sampleTipType && (
          <SellingPoint
            text={
              sampleTipType === 'summary'
                ? 'The features described below will be available for all live projects.'
                : "All assets are already pre-loaded for you in this sample demo, so there's no need to worry about meeting the upload requirements."
            }
          />
        )}

        {sideContent}
      </div>
    </div>
  );
};

export default PageWithSideBar;
